import type {
  PropertySelectionRow,
  SavedMapPlotRequestDetail,
} from "../../types";
import { getBookTypeFromRealEstateTypeLabel } from "../../components/AcquireMultipleBooksModal";
import { isValidSavedPlotForAcquireBook } from "@/utils/savedPlotValidation";

/**
 * SavedMapPlotRequestDetailをPropertySelectionRowに変換する
 * @param plot 変換元のSavedMapPlotRequestDetail
 * @param nextId 行ID
 * @returns PropertySelectionRow または null（バリデーション失敗時）
 */
export const convertSavedPlotToPropertyRow = (
  plot: SavedMapPlotRequestDetail,
  nextId: number
): PropertySelectionRow | null => {
  if (
    !isValidSavedPlotForAcquireBook(plot) ||
    plot.substituteLatitude === null ||
    plot.substituteLongitude === null
  ) {
    return null;
  }

  const realEstateType = plot.realEstateType ?? "土地";
  const bookType = getBookTypeFromRealEstateTypeLabel(realEstateType);

  // 地番または家屋番号の振り分け
  const chibanOrKaokuNumber =
    realEstateType === "土地"
      ? plot.requestChiban ?? ""
      : plot.requestKaokuNumber ?? "";

  const rawData = {
    prefName: plot.prefName ?? "",
    cityName: "",
    ooazaName: null,
    azaName: null,
    chiban: chibanOrKaokuNumber,
    addressChiban: chibanOrKaokuNumber,
    polygon: undefined,
    lat: plot.substituteLatitude,
    lng: plot.substituteLongitude,
    address: plot.requestAddress ?? "",
    area: null,
  };

  return {
    id: nextId,
    selected: true,
    bookType,
    prefName: plot.prefName ?? "",
    location: plot.requestLocation ?? "",
    chibanKaokuNumber: chibanOrKaokuNumber,
    area: null,
    isFeedOrigin: false,
    rawData,
    tags: [], // 保存済みピンクリック時はタグを空にする
    remarks: "", // 保存済みピンクリック時は備考を空にする
    pinType: "saved-plot",
  };
};
